/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class DisableAnimate implements angular.IDirective {
        restrict = "A";
        private animate: any;
        scope = {};

        constructor($animate: any) {
            this.animate = $animate
        }
        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var animate = this.animate;
            animate.enabled(element, false);
        }



        static factory(): angular.IDirectiveFactory {
            let directive = ($animate) => {
                return new DisableAnimate($animate);
            };
            directive.$inject = ["$animate"];
            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('disableAnimate', DisableAnimate.factory());

}
